import { useState, useEffect } from 'react'
import {
    FormControlLabel,
    FormControl,
    FormLabel,
    FormGroup,
    FormHelperText,
    Typography,
    Checkbox,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

export type DataCheckedType = {
    name?: string
    value?: boolean
}
type DataType = {
    id: number
    name: string
    value: string
}
type CheckboxGroupProps = {
    // onClick: (object: DataCheckedType) => void
    // onClick?: (data: number[]) => void
    onClick?: (data: number) => void
    options: DataType[]
    // name: string
    label?: string
    checked?: boolean
    disabled?: boolean
    required?: boolean
    labelPlacement?: 'top' | 'bottom' | 'start' | 'end'
    alignment?: 'vertical' | 'horizontal'
    color?: 'primary' | 'secondary'
    overrideClass?: {}
    helperText?: string
    input?: any
    meta?: any
}

const CheckboxGroupControl = (props: CheckboxGroupProps) => {
    const {
        onClick,
        options,
        // name,
        label,
        checked,
        disabled,
        required,
        alignment = 'horizontal',
        labelPlacement = 'end',
        color = 'primary',
        overrideClass,
        helperText,
        meta,
    } = props
    const isError = meta.error && meta.invalid && meta.touched ? true : false

    const { t } = useTranslation()
    const [state, setState] = useState({})
    const [dataChecked, setDataChecked] = useState<number[]>([])
    const haveChecked = !Object.keys(state).every((key) => state[key] === false)

    // useEffect(() => {
    //     const data = options.map(item => {
    //         if (item.value)
    //     })
    // }, [])

    return (
        <FormControl>
            {/* <FormLabel>
                <div>
                    <label>{label}</label>
                    <label style={{ color: '#d32f2f' }}>{required && ' *'}</label>
                </div>
            </FormLabel> */}
            <Typography>
                {label} {!disabled && required && <label style={{ color: '#d32f2f' }}>{' *'}</label>}
            </Typography>
            <FormGroup row={alignment === 'horizontal' ? true : false}>
                {options.map((item: DataType) => (
                    <FormControlLabel
                        control={
                            <Checkbox
                                name={item.value}
                                // checked={checked}
                                onChange={(event: any) => {
                                    setState({ ...state, [event.target.name]: event.target.checked })

                                    const itemClicked = options.filter((i) => i.name === event.target.name)[0]

                                    let newData = dataChecked.filter((id) => id !== itemClicked.id)
                                    if (event.target.checked) {
                                        newData.push(itemClicked.id)
                                    }
                                    setDataChecked(newData)
                                    onClick?.(item.id)
                                    // onClick?.(newData)

                                    // onClick({ ...state, [event.target.name]: event.target.checked })
                                }}
                                color={color}
                                classes={overrideClass}
                            />
                        }
                        label={item.name}
                        labelPlacement={labelPlacement}
                        disabled={disabled}
                    />
                ))}
            </FormGroup>
            {/* <FormHelperText>
                <label style={{ color: '#d32f2f' }}>
                    {!disabled ? (required && !haveChecked ? t('LABEL.SELECT_REQUIRED') : '') : ''}
                </label>
            </FormHelperText> */}
            <FormHelperText>
                <label style={{ color: '#d32f2f' }}>
                    {!disabled
                        ? required && !haveChecked && isError && meta.error
                            ? helperText
                                ? helperText
                                : t('LABEL.SELECT_REQUIRED')
                            : ''
                        : ''}
                </label>
            </FormHelperText>
        </FormControl>
    )
}

export default CheckboxGroupControl
